import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <p className="body-small">
              &copy; 2026 Harvest Holdings, LLC. All rights reserved.
            </p>
            <p className="body-small" style={{ marginTop: '4px', opacity: 0.7 }}>
              Building software that actually gets used.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
